import React, { useRef, useState } from 'react';
import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { BasicModal } from '@doda/io-react/common';
import styles from './index.module.scss';
import { CurrentConditionModalHead } from './components/CurrentConditionModalHead';
import { CurrentConditionModalBody } from './components/CurrentConditionModalBody';
import { CurrentConditionModalFoot } from './components/CurrentConditionModalFoot';

/**
 * 現在の検索条件モーダル
 * @interface Props
 */
interface Props {
  /** デフォルトの検索条件名 */
  defaultConditionName: string;
  /** 閉じるボタンクリック時のハンドラ */
  onClickClose: VoidFunction;
  /** 現在の検索条件データ */
  currentConditionData: SearchConditionLabelResponse;
  /** 保存ボタンクリック時のハンドラ */
  onClickSave: (conditionName: string) => void;
}

/**
 * 現在の検索条件モーダルを表示するコンポーネント
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} 現在の検索条件モーダルを表示する要素
 */
export const CurrentConditionModal: React.FC<Props> = ({
  defaultConditionName,
  onClickClose,
  currentConditionData,
  onClickSave, // packages/pc/src/common/logics/saveCurrentCondition/index.ts 参照
}) => {
  /** 検索条件名の状態 */
  const [conditionName, setConditionName] = useState(defaultConditionName);
  /** 保存ボタンがクリックされたかどうかの参照 */
  const isClickedRef = useRef(false);

  /** 入力変更時のハンドラ */
  const onChangeInput = (value: string) => setConditionName(value);

  /** 保存ボタンクリック時の処理 */
  const handleClickSave = () => {
    if (isClickedRef.current) return;
    isClickedRef.current = true;
    onClickSave(conditionName);
  };

  return (
    <BasicModal width={960} show onClickClose={onClickClose}>
      <CurrentConditionModalHead />
      <div className={styles['currentConditionModal__contents-wrapper']}>
        <CurrentConditionModalBody
          conditionName={conditionName}
          onChangeInput={onChangeInput}
          currentConditionData={currentConditionData}
        />
        <CurrentConditionModalFoot
          onClickClose={onClickClose}
          onClickSave={handleClickSave}
        />
      </div>
    </BasicModal>
  );
};
